/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdaptUnitPipe, CoreModule, SelectModule } from '@dm/core';
import { InfigoModule } from '@dm/live-material-infigo';

import { HostsService } from '../../../service/block-service/hosts/hosts.service';
import { HostsStrService } from '../../../service/block-service/hosts/hosts-str.service';
import { BaseInfoListComponent } from './components/base-info-list/base-info-list.component';
import { BasePerformaceChartComponent } from './components/base-performace-chart/base-performace-chart.component';
import { DefaultDetailComponent } from './components/default-detail/default-detail.component';
import { FileSystemBaseInfoComponent } from './components/file-systems-detail/file-system-base-info/file-system-base-info.component';
import { FileSystemResourceComponent } from './components/file-systems-detail/file-system-resource/file-system-resource.component';
import { FileSystemsDetailComponent } from './components/file-systems-detail/file-systems-detail.component';
import { HostBaseInfoComponent } from './components/host-detail/host-base-info/host-base-info.component';
import { HostDetailComponent } from './components/host-detail/host-detail.component';
import { HostResourceComponent } from './components/host-detail/host-resource/host-resource.component';
import { HostGroupBaseInfoComponent } from './components/host-group-detail/host-group-base-info/host-group-base-info.component';
import { HostGroupDetailComponent } from './components/host-group-detail/host-group-detail.component';
import { HostGroupResourceComponent } from './components/host-group-detail/host-group-resource/host-group-resource.component';
import { InfigoSelectComponent } from './components/infigo-select/infigo-select.component';
import { JumpTextComponent } from './components/jump-text/jump-text.component';
import { LogicPortBaseInfoComponent } from './components/logic-port-detail/logic-port-base-info/logic-port-base-info.component';
import { LogicPortDetailComponent } from './components/logic-port-detail/logic-port-detail.component';
import { LunBaseInfoComponent } from './components/lun-detail/lun-base-info/lun-base-info.component';
import { LunDetailComponent } from './components/lun-detail/lun-detail.component';
import { LunResourceComponent } from './components/lun-detail/lun-resource/lun-resource.component';
import { LunGroupBaseInfoComponent } from './components/lun-group-detail/lun-group-base-info/lun-group-base-info.component';
import { LunGroupDetailComponent } from './components/lun-group-detail/lun-group-detail.component';
import { LunGroupResourceComponent } from './components/lun-group-detail/lun-group-resource/lun-group-resource.component';
import { LunSnapShotBaseInfoComponent } from './components/lun-snap-shot-detail/lun-snap-shot-base-info/lun-snap-shot-base-info.component';
import { LunSnapShotDetailComponent } from './components/lun-snap-shot-detail/lun-snap-shot-detail.component';
import { PerformanceChartComponent } from './components/performance-chart/performance-chart.component';
import { PortGroupBaseInfoComponent } from './components/port-group-detail/port-group-base-info/port-group-base-info.component';
import { PortGroupDetailComponent } from './components/port-group-detail/port-group-detail.component';
import { PortGroupResourceComponent } from './components/port-group-detail/port-group-resource/port-group-resource.component';
import { RecycleBinComponent } from './components/recycle-bin/recycle-bin.component';
import { RecycleBinBaseInfoComponent } from './components/recycle-bin/recycle-bin-base-info/recycle-bin-base-info.component';
import { ResourceTableModule } from './components/resource-table/resource-table.module';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { SourceDetailComponent } from './components/source-detail/source-detail.component';
import { TenantBaseInfoComponent } from './components/tenant-detail/tenant-base-info/tenant-base-info.component';
import { TenantDetailComponent } from './components/tenant-detail/tenant-detail.component';
import { InitStatusComponent } from './init-status/init-status.component';
import { InitStatusModule } from './init-status/init-status.module';
import { ErrorDisplayComponent } from './input/error-display/error-display.component';
import { InputComponent } from './input/input.component';
import { MonopolizeSearchComponent } from './monopolize-search/monopolize-search.component';
import { SearchStatusComponent } from './search-status/search-status.component';

@NgModule({
    declarations: [
        InitStatusComponent,
        SearchStatusComponent,
        MonopolizeSearchComponent,
        SkeletonComponent,
        BaseInfoListComponent,
        SourceDetailComponent,
        DefaultDetailComponent,
        LunDetailComponent,
        LunBaseInfoComponent,
        LunResourceComponent,
        LunGroupDetailComponent,
        LunGroupBaseInfoComponent,
        LunGroupResourceComponent,
        HostDetailComponent,
        HostBaseInfoComponent,
        HostResourceComponent,
        HostGroupDetailComponent,
        HostGroupBaseInfoComponent,
        HostGroupResourceComponent,
        PortGroupDetailComponent,
        PortGroupBaseInfoComponent,
        PortGroupResourceComponent,
        TenantDetailComponent,
        TenantBaseInfoComponent,
        LogicPortDetailComponent,
        LogicPortBaseInfoComponent,
        LunSnapShotDetailComponent,
        LunSnapShotBaseInfoComponent,
        FileSystemsDetailComponent,
        FileSystemBaseInfoComponent,
        FileSystemResourceComponent,
        BasePerformaceChartComponent,
        PerformanceChartComponent,
        InfigoSelectComponent,
        InputComponent,
        ErrorDisplayComponent,
        JumpTextComponent,
        RecycleBinComponent,
        RecycleBinBaseInfoComponent,
    ],
    providers: [
        HostsService,
        HostsStrService,
        AdaptUnitPipe,
    ],
    imports: [
        CommonModule,
        InfigoModule,
        CoreModule,
        FormsModule,
        InitStatusModule,
        SelectModule,
        ResourceTableModule,
    ],
})
export class GlobalInfigoModule {
}
